// views/Profile/utils/billingCycle.js
//
// Cuándo se reinicia el ciclo, y cuántos días faltan.
//
// Vivía dentro de `WalletSummaryInsights`, y ahora la cabecera del wallet
// necesita el mismo número para decir "resets in 30 days". Dos copias del
// mismo cálculo se separan, y cuando lo hacen la pantalla dice dos cosas
// distintas sobre la misma fecha en el mismo scroll.

const DAY_MS = 24 * 60 * 60 * 1000;

export const daysBetween = (a, b) =>
  Math.max(0, (b.getTime() - a.getTime()) / DAY_MS);

/**
 * La próxima fecha de reinicio, estimada a partir del día del mes del ancla.
 *
 * Se apoya en el día del ancla y no en sumar 30 días: un ciclo que empieza el
 * 31 tiene que caer el último día de los meses que no lo tienen, y sumando
 * días se corre solo hacia atrás mes a mes.
 */
export const estimateNextReset = ({ anchorDate, lastResetAt }) => {
  if (!anchorDate) return null;
  const anchor = new Date(anchorDate);
  if (Number.isNaN(anchor.getTime())) return null;
  const day = anchor.getUTCDate();
  const base = lastResetAt ? new Date(lastResetAt) : new Date();
  if (Number.isNaN(base.getTime())) return null;
  const next = new Date(Date.UTC(base.getUTCFullYear(), base.getUTCMonth() + 1, day));
  const lastDay = new Date(
    Date.UTC(next.getUTCFullYear(), next.getUTCMonth() + 1, 0)
  ).getUTCDate();
  if (day > lastDay) next.setUTCDate(lastDay);
  return next;
};

/** Días que faltan para el reinicio, o `null` si no se puede saber. */
export const daysUntilReset = ({ anchorDate, lastResetAt, now = new Date() }) => {
  const next = estimateNextReset({ anchorDate, lastResetAt });
  return next ? Math.ceil(daysBetween(now, next)) : null;
};
